export type APIError = {
  errors: {};
  status: number;
  title: string;
  type: string;
};

type ErrorWithMessage = {
  message: string;
};

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
  return typeof error === "object" && error !== null && "message" in error;
}

function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
  if (isErrorWithMessage(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
}

export function getErrorMessage(error: unknown) {
  console.log(error);
  return toErrorWithMessage(error).message;
}

export function ErrorHandler(errors: any) {
  let errorMessage = "";
  Object.values(errors).forEach(
    (error: any) => (errorMessage += `${error[0]}\n`)
  );
  return errorMessage;
}

export function APIResponseHandler(response) {
  if (
    response.data === "" &&
    (response.status === 200 || response.status === 204)
  ) {
    return true;
  }
  if (response.status === 500) {
    throw new Error("There was an internal error while updating event.");
  } else {
    return response.data;
  }
}

export function storeResponseHandler(
  resp: any,
  successMessage: string,
  addToast: any
) {
  if (resp === true || (resp.data && !resp.isError)) {
    addToast("Success", successMessage, "success");
  }
  if ((resp as APIError).errors) {
    addToast(
      (resp as APIError).title,
      ErrorHandler((resp as APIError).errors),
      "error"
    );
  }
}
